<ul class="tag-list">
  <li *ngFor="let tag of tags" class="tag-default tag-pill tag-outline">{{ tag }}</li>
</ul>
